var map = {
	"./AdvertisementApi.js": 46555,
	"./AnnouncementApi.js": 50947,
	"./AuditTrailApi.js": 79233,
	"./AuthApi.js": 55264,
	"./BroadcastApi.js": 22773,
	"./CenterLocationApi.js": 25152,
	"./ContactUsApi.js": 82492,
	"./CountryApi.js": 96326,
	"./DashboardApi.js": 54176,
	"./GoogleAuthenticatorApi.js": 49878,
	"./KioskApi.js": 35597,
	"./LocaleApi.js": 31896,
	"./LocationPriceApi.js": 44148,
	"./NationalityApi.js": 78434,
	"./PickupApi.js": 24966,
	"./PickupLocationApi.js": 52527,
	"./PostcodeApi.js": 5991,
	"./RecyclableCategoryApi.js": 96256,
	"./RecyclingHistoryApi.js": 87844,
	"./ReferralCodeApi.js": 42038,
	"./StateApi.js": 97431,
	"./SupportiveApi.js": 71447,
	"./SystemVariableApi.js": 81841,
	"./UserApi.js": 19315,
	"./UserAssetBalanceListApi.js": 76143,
	"./UserAssetHistoryApi.js": 73851,
	"./UserVoucherApi.js": 42905,
	"./VoucherApi.js": 3806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38292;